import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useAppSelector } from '../../../../redux/store';
import { getCurrencyAmountString } from '../../../../utils/currencyUtils';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  line-height: 90%;
`;
const COST_TEXT_CSS = css `
  opacity: 50%;
`;
export const SideBetButtonLabel = () => {
    const sideBetCost = useAppSelector((state) => state.poker.sideBetCost);
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsx("span", { children: "Side Bet" }), sideBetCost && _jsx("span", { css: COST_TEXT_CSS, children: getCurrencyAmountString(sideBetCost, 'jacks') })] }));
};
